const typography = {
  h1: {
    fontWeight: 300,
    fontSize: 96,
    letterSpacing: '-1.5px'
  },
  h2: {
    fontWeight: 300,
    fontSize: 60,
    letterSpacing: '-0.5px'
  },
  h3: {
    fontWeight: 400,
    fontSize: 48,
    letterSpacing: 0
  },
  h4: {
    fontWeight: 400,
    fontSize: 32,
    letterSpacing: 0
  },
  h5: {
    fontWeight: 400,
    fontSize: 24,
    letterSpacing: 0
  },
  h6: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '0.15px'
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: 18,
    letterSpacing: 0
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: 0
  },
  body1: {
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 0
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0
  },
  button: {
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: '0.26px'
  },
  caption: {
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: '0.12px'
  },
  overline: {
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: '1px'
  }
};

export default typography;
